import React, { PropsWithChildren, useEffect } from 'react'
import { useUnit } from 'effector-react'
import {
  $isRequestSuccess,
  $requestError,
  notificationMounted,
  setRequestError,
  setRequestSuccess,
} from './index'
import { notification } from 'antd'
import { NotificationPlacement } from 'antd/es/notification/interface'

export const Notification: React.FC<PropsWithChildren> = ({ children }) => {
  const [api, contextHolder] = notification.useNotification()

  const isRequestSuccess = useUnit($isRequestSuccess)
  const error = useUnit($requestError)

  const openRequestSuccessNotification = (
    placement: NotificationPlacement,
    type: string,
  ) => {
    api.success({
      message: type,
      placement,
      onClose: () => {
        setRequestSuccess(false)
      },
    })
  }

  const openRequestErrorNotification = (
    placement: NotificationPlacement,
    type: string,
    message: string,
  ) => {
    api.error({
      message: type,
      description: message,
      placement,
      onClose: () => {
        setRequestError(null)
      },
    })
  }

  useEffect(() => {
    if (isRequestSuccess) {
      openRequestSuccessNotification('topRight', 'Request success')
    }
  }, [isRequestSuccess])

  useEffect(() => {
    if (error) {
      openRequestErrorNotification(
        'topRight',
        'Request error',
        `${error.code}: ${error.message}`,
      )
    }
  }, [error])

  useEffect(() => {
    notificationMounted({ api })
  }, [api])

  return (
    <>
      {contextHolder}
      {children}
    </>
  )
}
